module.exports = __webpack_public_path__ + "static/media/arrow-footer.78cded9e.svg";